import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';

import COLOR_THEMES from "../../../../../colorThemes";

import {setGroheFiltersSearchText} from "../../../../../actions/groheFunctions";
import {searchAllProductsRequest, searchProductRequest} from "../../../../../api/search-api";
import {getCurrentLayout} from "../../../../appLayout";
import {updateNavigationCount} from "../../../../../actions/lookFunctions";
import {setNavigationLoading} from "../../../../../actions/navigationFunctions";
import useDebounce from "../../../../../misc/helperHooks";

const GroheFiltersSearchInput = (props) => {
  const {activeTheme, groheFiltersSearchText, setGroheFiltersSearchText, lookActiveCategory, updateNavigationCount,
    setNavigationLoading, propsFeatureGroup, shouldSearchInAllGroups} = props;

  const layout = getCurrentLayout();
  const featureGroup = propsFeatureGroup || layout.getFeatureGroupByPartId(lookActiveCategory);

  const setShowLoader = (ended) => {
    setNavigationLoading(ended);
    if (!ended) {
      updateNavigationCount();
    }
  }

  useDebounce(async () => {
    if (shouldSearchInAllGroups) {
      await searchAllProductsRequest(groheFiltersSearchText, setNavigationLoading); // mega request
      updateNavigationCount();
      return
    }
    if (featureGroup && !featureGroup.getRealFeaturesReceivedProperty()) {
      return searchProductRequest(featureGroup, groheFiltersSearchText, setShowLoader)
    }
  }, [groheFiltersSearchText], 800);

  const handleSearchInputChange = async (event) => {
    setGroheFiltersSearchText(event.currentTarget.value);
  }

  return (
    <div className="lk-search">
      <InputLabel shrink htmlFor="search-product" style={{ color: COLOR_THEMES[activeTheme].primary }}>
        <FormattedMessage id={"grohe.filter.searchProduct"}/>
      </InputLabel>
      <TextField id="search-product" label="" size="small" variant="outlined" fullWidth={true} type="search"
                 value={groheFiltersSearchText}
                 onChange={handleSearchInputChange} />
    </div>
  )
};

GroheFiltersSearchInput.propTypes = {
  shouldSearchInAllGroups: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {groheFiltersSearchText} = store.groheState;
  const {activeTheme} = store.serverState;
  const {lookActiveCategory} = store.lookState;

  return {
    groheFiltersSearchText,
    activeTheme,
    lookActiveCategory,
  };
};

const mapDispatchToProps = {
  setGroheFiltersSearchText,
  updateNavigationCount,
  setNavigationLoading,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFiltersSearchInput)
);
